class Enum {
  constructor (obj) {
    for(let name in obj) {
      this[name] = obj[name];
      this[obj[name]] = name;
    }
  }
}

export default Enum;